import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=7c07bda7&"
import script from "./PageLoading.vue?vue&type=script&lang=js&"
export * from "./PageLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c07bda7')) {
      api.createRecord('7c07bda7', component.options)
    } else {
      api.reload('7c07bda7', component.options)
    }
    module.hot.accept("./PageLoading.vue?vue&type=template&id=7c07bda7&", function () {
      api.rerender('7c07bda7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/PageLoading.vue"
export default component.exports